<form #stockForm="ngForm" class="flex flex-col gap-4" (ngSubmit)="saveStock()">
    @if (isLoadingData) {
        <div class="flex justify-center">
            <p-progress-spinner ariaLabel="loading" />
        </div>
    }
    @else {
        <div class="col-span-8 flex relative justify-between border border-sky-500 dark:border-sky-400 px-4 py-2 mt-4 rounded-md">
            <span class="card  absolute top-0 -translate-y-1/2 border border-sky-500 dark:border-sky-400 text-sky-500 dark:text-sky-400 rounded-sm px-1.5! py-0.5!">Prix recommandé sur le marché</span>
            <div class="pt-2">
                @if(isRecommendedPriceLoaded){
                    @if (recommendedPrice && recommendedPrice?.analyses) {
                        <div class="flex items-center py-1">
                            <p-tag [severity]="utilityService.getStateSeverity('NEUF')" [value]="utilityService.getStateLabel('NEUF')" />
                            @if (recommendedPrice.analyses.neuf && recommendedPrice.analyses.neuf.pv_conseille_min && recommendedPrice.analyses.neuf.pv_conseille_max) {
                                <span class="ml-2">Entre</span>
                                <code class="text-sky-500 dark:text-sky-400 mx-1">{{ recommendedPrice.analyses.neuf?.pv_conseille_min | currency: 'EUR' }}</code>
                                <span>et</span>
                                <code class="text-sky-500 dark:text-sky-400 mx-1">{{ recommendedPrice.analyses.neuf?.pv_conseille_max | currency: 'EUR' }}</code>
                                <span> - Fiabilité :</span>
                                @if (recommendedPrice.analyses.neuf.fiabilite) {
                                    <code class="mx-1" [class]="utilityService.getFiabilityClass(recommendedPrice.analyses.neuf.fiabilite)">{{ (recommendedPrice.analyses.neuf.fiabilite / 100) | percent:'1.0-2' }}</code>
                                }
                            } @else {
                                <span class="text-sky-500 dark:text-sky-400 ml-2">Aucun prix recommandé disponible</span>
                            }
                        </div>
                        <div class="flex items-center py-1">
                            <p-tag [severity]="utilityService.getStateSeverity('OCCASION')" [value]="utilityService.getStateLabel('OCCASION')" />
                            @if (recommendedPrice.analyses.occasion && recommendedPrice.analyses.occasion.pv_conseille_min && recommendedPrice.analyses.occasion.pv_conseille_max) {
                                <span class="ml-2">Entre</span>
                                <code class="text-sky-500 dark:text-sky-400 mx-1">{{ recommendedPrice.analyses.occasion?.pv_conseille_min | currency: 'EUR' }}</code>
                                <span>et</span>
                                <code class="text-sky-500 dark:text-sky-400 mx-1">{{ recommendedPrice.analyses.occasion?.pv_conseille_max | currency: 'EUR' }}</code>
                                <span> - Fiabilité :</span>
                                @if (recommendedPrice.analyses.occasion.fiabilite) {
                                    <code class="mx-1" [class]="utilityService.getFiabilityClass(recommendedPrice.analyses.occasion.fiabilite)">{{ (recommendedPrice.analyses.occasion.fiabilite / 100) | percent:'1.0-2' }}</code>
                                }
                            }
                            @else {
                                <span class="text-sky-500 dark:text-sky-400 ml-2">Aucun prix recommandé disponible</span>
                            }
                        </div>
                    }
                    @else {
                    <span class="text-sky-500 dark:text-sky-400">Aucun prix recommandé disponible</span>
                }
                }
            </div>
            @if(!isRecommendedPriceLoaded){
                <i class="pi pi-spin pi-spinner text-sky-500 dark:text-sky-400"></i>
            }
        </div>
        <div class="grid grid-cols-2 gap-4">
            <div class="col-span-2">
                <label for="etat">État</label>
                <div class="flex flex-wrap gap-4 mt-2">
                    <div class="flex items-center">
                        <p-radiobutton #etat="ngModel" name="etat" value="NEUF" [(ngModel)]="stock.etat" inputId="etat1" aria-describedby="etat-help" required />
                        <label for="etat1" class="ml-2"><p-tag severity="success" value="Neuf" /></label>
                    </div>

                    <div class="flex items-center">
                        <p-radiobutton #etat="ngModel" name="etat" value="RECONDITIONNE" [(ngModel)]="stock.etat" inputId="etat2" aria-describedby="etat-help" required />
                        <label for="etat2" class="ml-2"><p-tag severity="info" value="Reconditionné" /></label>
                    </div>

                    <div class="flex items-center">
                        <p-radiobutton #etat="ngModel" name="etat" value="OCCASION" [(ngModel)]="stock.etat" inputId="etat3" aria-describedby="etat-help" required />
                        <label for="etat3" class="ml-2"><p-tag severity="warn" value="Occasion" /></label>
                    </div>

                    <div class="flex items-center">
                        <p-radiobutton #etat="ngModel" name="etat" value="HS" [(ngModel)]="stock.etat" inputId="etat4" aria-describedby="etat-help" required />
                        <label for="etat4" class="ml-2"><p-tag severity="danger" value="HS" /></label>
                    </div>
                </div>
                <div class="mt-1">
                    <small id="etat-help">Sélectionner l'état dans ces choix</small>
                </div>
                @if (etat.invalid && (etat.dirty || etat.touched)) {
                    <p-message severity="error" size="small" variant="simple">L'état est obligatoire</p-message>
                }
            </div>
            <div class="col-span-1 flex flex-col gap-4">
                <div class="flex flex-col items-start gap-2 mb-0.5">
                    <label for="note">Note</label>
                    <p-rating #note="ngModel" [(ngModel)]="stock.note" name="note" id="note" [invalid]="note.invalid && (note.touched)" aria-describedby="note-help" required >
                        <ng-template #onicon>
                            <i class="pi pi-star-fill !text-xl text-primary-500"></i>
                        </ng-template>
                        <ng-template #officon>
                            <i class="pi pi-star !text-xl text-gray-500"></i>
                        </ng-template>
                    </p-rating>
                    <small id="note-help">Note comprise entre 1 et 5</small>
                    @if (note.invalid && (note.dirty || note.touched)) {
                        <p-message severity="error" size="small" variant="simple">La note est obligatoire</p-message>
                    }
                </div>

                <div>
                    <p-floatlabel variant="in" class="mb-2">
                        <p-select #secteur="ngModel" [options]="secteurs" appendTo="body" fluid name="secteur" id="secteur" [(ngModel)]="stock.secteur_id" optionLabel="nom" optionValue="id" [filter]="false" filterBy="name" [showClear]="true" aria-describedby="secteur-help" required >
                            <ng-template #selectedItem let-selectedOption>
                                <div class="inline-block w-full px-2 py-1 rounded-sm" [class]="utilityService.getSectorClassColor(selectedOption.nom)">
                                    <div>{{ selectedOption.nom }}</div>
                                </div>
                            </ng-template>
                            <ng-template let-secteur #item>
                                <div class="inline-block w-full px-2 py-1 rounded-sm" [class]="utilityService.getSectorClassColor(secteur.nom)">
                                    <div>{{ secteur.nom }}</div>
                                </div>
                            </ng-template>
                        </p-select>
                        <label for="secteur">Secteur</label>
                    </p-floatlabel>
                    <small id="secteur-help">Sélectionner le secteur dans la liste</small>
                    @if (secteur.invalid && (secteur.dirty || secteur.touched)) {
                        <p-message severity="error" variant="simple">Le secteur est obligatoire</p-message>
                    }
                </div>

                <div class="flex flex-col gap-2">
                    <p-floatlabel variant="in">
                        <input pInputText #etagere="ngModel" [(ngModel)]="stock.etagere" fluid name="etagere" id="etagere" autocomplete="off" aria-describedby="etagere-help" required pattern="[a-zA-Z0-9]" (input)="stock.etagere = stock.etagere?.toUpperCase()" />
                        <label for="etagere">Étagère</label>
                    </p-floatlabel>
                    <small id="etagere-help">Code alphanumérique [A-Z0-9] de l'étagère</small>
                    @if (etagere.invalid && (etagere.dirty || etagere.touched)) {
                        <p-message severity="error" variant="simple">L'étagère est obligatoire</p-message>
                    }
                </div>

                <div class="flex flex-col gap-2">
                    <p-floatlabel variant="in">
                        <p-inputnumber #rayon="ngModel" [(ngModel)]="stock.rayon" fluid name="rayon" id="quantite" autocomplete="off" [min]="0" [max]="199" aria-describedby="rayon-help" required />
                        <label for="rayon">Rayon</label>
                    </p-floatlabel>
                    <small id="rayon-help">Nombre entre 0 et 199.</small>
                    @if (rayon.invalid && (rayon.dirty || rayon.touched)) {
                        <p-message severity="error" variant="simple">Le rayon est obligatoire</p-message>
                    }
                </div>
            </div>

            <div class="col-span-1 flex flex-col gap-4">
                <div>
                    <p-floatlabel variant="in" class="mb-2">
                        <p-inputnumber #prix="ngModel" [(ngModel)]="stock.prix" fluid name="prix" id="prix" autocomplete="off" suffix=" €" mode="decimal" [min]="0" [minFractionDigits]="2" [maxFractionDigits]="2" aria-describedby="prix-help" required />
                        <label for="prix">Prix</label>
                    </p-floatlabel>
                    <small id="prix-help">Décimal supérieur ou égal à 0</small>
                    @if (prix.invalid && (prix.dirty || prix.touched)) {
                        <p-message severity="error" variant="simple">Le prix est obligatoire</p-message>
                    }
                </div>

                <div>
                    <p-floatlabel variant="in" class="mb-2">
                        <p-inputnumber #quantite="ngModel" [(ngModel)]="stock.quantite" fluid name="quantite" id="quantite" autocomplete="off" [min]="0" aria-describedby="quantite-help" required />
                        <label for="quantite">Quantité</label>
                    </p-floatlabel>
                    <small id="quantite-help">Nombre entier supérieur ou égal à 0</small>
                    @if (quantite.invalid && (quantite.dirty || quantite.touched)) {
                        <p-message severity="error" variant="simple">La quantité est obligatoire</p-message>
                    }
                </div>

                <div class="flex flex-col items-start gap-2 mb-0.5">
                    <label for="note">Ebay</label>
                    <p-toggleswitch [(ngModel)]="stock.ebay" name="ebay" id="ebay" aria-describedby="ebay-help"></p-toggleswitch>
                    <small id="ebay-help">Ce stock est-il en vente sur Ebay ?</small>
                </div>

                @if(stock.ebay == true) {
                    <div class="flex flex-col gap-2">
                        <p-floatlabel variant="in">
                            <input pInputText #url_ebay="ngModel" [(ngModel)]="stock.url_ebay" type="url" fluid name="url_ebay" id="url_ebay" autocomplete="off" aria-describedby="url_ebay-help" (input)="stock.etagere = stock.etagere?.toUpperCase()" />
                            <label for="url_ebay">Url Ebay</label>
                        </p-floatlabel>
                        <small id="url_ebay-help">Lien de la page Ebay pour ce stock/produit</small>
                    </div>
                }
            </div>

            <div class="col-span-2">
                <p-floatlabel variant="in" class="mb-2">
                    <textarea pInputTextarea #commentaire="ngModel" [(ngModel)]="stock.commentaire" fluid name="commentaire" id="commentaire" autocomplete="off" rows="3" aria-describedby="commentaire-help" ></textarea>
                    <label for="commentaire">Commentaire</label>
                </p-floatlabel>
                <small id="commentaire-help">Ajouter un commentaire (optionnel)</small>
            </div>
        </div>

        <div class="flex flex-row justify-between mt-4">
            <p-button label="Annuler" icon="pi pi-times" text severity="danger" (click)="hideDialog()" />
            <p-button label="Sauvegarder" icon="pi pi-save" iconPos="right" type="submit" [disabled]="!stockForm.valid || !hasChanges()" [loading]="isSendingDatas" />
        </div>
    }
</form>
